//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RbPanel from '@/elements/panel/rb-panel.vue'
import RbTeleport from '@/elements/teleport/rb-teleport.vue'
export default {
  name: 'rb-change-style',
  components: {
    RbPanel,
    RbTeleport,
  },
  data() {
    return {
      panelIsVisible: false,
    }
  },
  methods: {
    onChangeStylePanelClick() {
      this.panelIsVisible = true
    },
    onClosePanel() {
      this.panelIsVisible = false
    },
  },
}
